import React, { useRef } from 'react'
import Slider from "react-slick";
import { getImages } from '../Common/const'
import SeoMeta from '../Common/SeoMeta';

const reviewsList = [
    {
        name: "Darren Magot",
        date: '2 months ago',
        content:
            "I had a great experience with these guys. They have such a wide variety of unique vehicles. Definitely will be going back whenever I’m in the area to see what’s new.",
    },
    {
        name: "R PHOTOSTUDIOS",
        date: 'a month ago',
        content:
            "Jackson was very welcoming when we visited the showroom. Knowledgeable and patient with my son who was so excited to see their cars.",
    },
    {
        name: "cat lover",
        date: '2 months ago',
        content:
            "Tim had great communication. I didn’t see the car in person, so I had to trust…and I ended up very pleased. As described. Thank you",
    },

    {
        name: "Alek Arciniega",
        date: 'a month ago',
        content:
            "Awesome place to go look at exotic cars. The guys working there were very helpful and informative. Definitely recommend coming here and checking this place out.",
    },
    {
        name: "Muntasir Hoque",
        date: '6 days ago',
        content:
            "Excellent experience with purchase and delivery of a vehicle from EEC! Jaxon was my point of contact, and he was incredibly knowledgeable and friendly the entire process. They delivered the vehicle to a location of my choosing, and made the entire experience a pleasure. I cannot recommend Jaxon and EEC enough. This is the best place in California to purchase exotic automobiles!",
    },

    {
        name: "Ishnmuich Perez",
        date: 'a month ago',
        content:
            "Very friendly professional staff. Not only were they very friendly and courteous with my son, but they gave us good information on their weekly car shows held at the parking lot.",
    },
    {
        name: "Summer Shaffer",
        date: '2 months ago',
        content:
            "Whole staff was super friendly and very knowledgeable. Was the easiest car purchase I’ve ever made. Will be my first call when I’m ready for something new!",
    },
];
const CustomerReviews = () => {
    const sliderRef = useRef(null);
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };
  return (
    <>
      <SeoMeta
        title="European Exotic Center customer reviews in Tampa, FL and San Clemente, CA"
        description="Read some European Exotic Center customer reviews. See what our customers are saying about our car dealership."
        keywords=""
        ogTitle="European Exotic Center customer reviews in Tampa, FL and San Clemente, CA"
        ogDescription="Read some European Exotic Center customer reviews. See what our customers are saying about our car dealership."
      />
      <section className="common-banner-wrap repair-banner consign-banner">
        <img src={getImages('company-reviews-hero.webp')} alt='Company Reviews' />
        <div className="container">
          <div className='common-banner-pos pt-5 text-center'>
            <h1 className='banner-lg-title text-uppercase wow reveal fadeInUp'>Company Reviews</h1>
            <div className='md-title font-2em fw-400 text-center mt-3 mb-4 wow reveal fadeInUp avenir-next'>Our Happy Customers</div>
          </div>
        </div>
      </section>
      <section className='customer-review-wrap'>
        <div className='customer-review-block'>
          <div className='container mxw-1170'>
            <h1 className='lg-title font-2-5em text-uppercase mb-3 wow reveal fadeInUp'>How Are We Doing?</h1>
            <h2 className='lg-title font-1-9em text-uppercase mb-5 text-orange text-uppercase wow reveal fadeInUp'>At European Exotic Center, we’re proud to have earned the trust and loyalty of customers</h2>
            <div className='row'>
              <div className='col-md-6'>
                <div className='common-text wow reveal fadeInLeft'>
                  <p>At European Exotic Center, we’re proud to have earned the trust and loyalty of customers not just from Tampa, but from across the country—including cities as far as Las Vegas, Los Angeles, and San Diego. Drivers travel from near and far to experience our personalized service, world-class selection of pre-owned luxury and exotic vehicles, and the unmatched expertise of our knowledgeable team. Whether it's your first exotic car or an addition to your collection, our customers consistently share how smooth, transparent, and memorable their experience was at European Exotic Center.</p>
                </div>
              </div>
              <div className='col-md-6 text-end wow reveal fadeInRight mt-md-0 mt-4'>
                <div className='d-inline-block'>
                  <div className='mb-md-1 mb-2'>
                    <img src={getImages('review-star.png')} alt='review' />
                  </div>
                  <div className='xs-title font-1-2em text-uppercase fw-700 text-center'>From <span className='font-1-5em text-red text-orange'>147</span> Customers Across the Country</div>
                </div>
              </div>
            </div>

            <div className='reveal wow reveal fadeIn mt-100'>
              <Slider ref={sliderRef} {...settings} className='review-slider'>
                {reviewsList.map((review, index) => (
                  <div className="review-item" key={index}>
                    <div className="review-box">
                      <div className="d-flex justify-content-between mt-1">
                        <div>
                          <div className="reviewer-name">{review.name}</div>
                          <div className="d-flex align-items-center">
                            {[...Array(5)].map((_, i) => (
                              <img key={i} className="me-1 rs-icon" src={getImages("star.svg")} alt="star" />
                            ))}
                          </div>
                        </div>
                        <div>
                          <div className="quote-icon mb-2">
                            <img src={getImages("quote-shape.png")} alt="quote" />
                          </div>
                        </div>
                      </div>
                      <div className="review-mnh">
                        <p className="clamp-4">
                          {review.content}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}

              </Slider>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default CustomerReviews